export function globalBackdropStore() {
  return {
    show: false,
    toggle(value) {
      if (this.show === value) return;

      this.show = value;
      window.dispatchEvent(new CustomEvent("toggle-menu-overlay", { detail: { open: value } }));
    }
  };
}
